import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTasks: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="tasks, lists, todos"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 9.5L16.25 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 14.5L16.25 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="8" cy="14.5" r="1" fill="currentColor"/><circle cx="8" cy="9.5" r="1" fill="currentColor"/></CentralIconBase>;
};

export default IconTasks;
